import axios from 'axios'

import { ihMedia, ihLive } from '@/api/config'

export function meetRegister(params, token, reqCode, reqTime, sign) {
  const url = ihMedia + '/meet/register'
  // console.log(url,params, token, reqCode, reqTime, sign,'axios打印')
  return axios({
    method: 'post',
    url: url,
    headers: {
      token: token,
      'req-code': reqCode,
      'req-time': reqTime,
      sign: sign,
    },
    data: params,
  }).then(res => {
    return Promise.resolve(res.data)
  })
}

// 通过会议码删除会议
export function deleteMeet(params, token, reqCode, reqTime, sign) {
  const url = ihMedia + '/meet/' + params.code
  return axios({
    method: 'delete',
    url: url,
    headers: {
      token: token,
      'req-code': reqCode,
      'req-time': reqTime,
      sign: sign,
    },
  }).then(res => {
    return Promise.resolve(res.data)
  })
}

// 推流请求
export function meetPublish(link, params) {
  const url = ihLive + '/rtc/v1/publish' + link
  return axios({
    method: 'post',
    url: url,
    data: params,
  }).then(res => {
    return Promise.resolve(res.data)
  })
}

// 拉流请求
export function meetPlay(link, params) {
  const url = ihLive + '/rtc/v1/play' + link
  return axios({
    method: 'post',
    url: url,
    data: params,
  }).then(res => {
    return Promise.resolve(res.data)
  })
}

// .通过会议码查询会议和客户端信息
export function searchMeet(params, token, reqCode, reqTime, sign) {
  const url = ihMedia + '/meet/' + params
  return axios({
    method: 'get',
    url: url,
    headers: {
      token: token,
      'req-code': reqCode,
      'req-time': reqTime,
      sign: sign,
    },
  }).then(res => {
    return Promise.resolve(res.data)
  })
}
